import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Home, PackageSearch, ArrowLeft, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import SEOHead from "@/components/SEOHead";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center bg-[#FAF8F4] px-4 py-16">
      <SEOHead pageKey="not-found" />
      <div className="max-w-lg w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#b1976b]/15 mb-5">
          <Compass size={30} className="text-[#b1976b]" />
        </div>
        <p className="font-heading font-bold text-6xl text-[#1A1A1A] mb-2" data-testid="not-found-code">404</p>
        <h1 className="font-heading font-bold text-2xl text-[#1A1A1A] mb-3">Page Not Found</h1>
        <p className="text-sm text-[#54595f] leading-relaxed mb-8">
          The link you followed is broken or the page has been moved. Check the URL, or use one of the options below to get back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button data-testid="not-found-back-btn" variant="outline" onClick={() => navigate(-1)} className="border-[#54595f]/30 text-[#1A1A1A]">
            <ArrowLeft size={15} className="mr-2" /> Go Back
          </Button>
          <Link to="/">
            <Button data-testid="not-found-home-btn" className="w-full bg-[var(--brand-primary)] hover:bg-[#9E855A] text-white">
              <Home size={15} className="mr-2" /> Back to Home
            </Button>
          </Link>
          <Link to="/track">
            <Button data-testid="not-found-track-btn" variant="outline" className="w-full border-[var(--brand-primary)] text-[var(--brand-primary)]">
              <PackageSearch size={15} className="mr-2" /> Track Application
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
